import { supabase } from "@/integrations/supabase/client";

export function useTutorial() {
  const restartTutorial = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    if (user) {
      await supabase
        .from("profiles")
        .update({ tutorial_completed: false })
        .eq("id", user.id);
      window.location.reload();
    }
  };

  return { restartTutorial };
}
